"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var query_string_1 = __importDefault(require("query-string"));
var regex_1 = require("./regex");
var utils_1 = require("./utils");
var Route = /** @class */ (function () {
    function Route(_a) {
        var path = _a.path, component = _a.component, onEnter = _a.onEnter, beforeExit = _a.beforeExit, onParamsChange = _a.onParamsChange, beforeEnter = _a.beforeEnter, onExit = _a.onExit, title = _a.title;
        this.path = path;
        this.component = component;
        this.onEnter = onEnter;
        this.beforeExit = beforeExit;
        this.onParamsChange = onParamsChange;
        this.beforeEnter = beforeEnter;
        this.title = title;
        this.onExit = onExit;
        this.originalPath = this.path;
        //if there are optional parameters, replace the path with a regex expression
        this.path =
            this.path.indexOf('?') === -1
                ? this.path
                : this.path.replace(regex_1.optionalRegex, '/?([^/]*)?$');
        this.rootPath = this.getRootPath();
        //bind
        this.getRootPath = this.getRootPath.bind(this);
        this.replaceUrlParams = this.replaceUrlParams.bind(this);
        this.getParamsObject = this.getParamsObject.bind(this);
    }
    /*
   Sets the root path for the current path, so it's easier to determine if the route entered/exited or just some params changed
   Example: for '/' the root path is '/', for '/profile/:username/:tab' the root path is '/profile'
   */
    Route.prototype.getRootPath = function () {
        return "/" + this.path.split('/')[1];
    };
    /*
   replaces url params placeholders with params from an object
   Example: if url is /book/:id/page/:pageId and object is {id:100, pageId:200} it will return /book/100/page/200
   */
    Route.prototype.replaceUrlParams = function (params, queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        var jsParams = params && mobx_1.toJS(params);
        var jsQueryParams = mobx_1.toJS(queryParams);
        var queryParamsString = query_string_1.default
            .stringify(jsQueryParams)
            .toString();
        var hasQueryParams = queryParamsString !== '';
        var newPath = this.originalPath;
        utils_1.getRegexMatches(this.originalPath, regex_1.paramRegex, 
        // eslint-disable-next-line
        function (_a) {
            var _fullMatch = _a[0], paramKey = _a[1], paramKeyWithoutColon = _a[2];
            var value = jsParams
                ? jsParams[paramKeyWithoutColon]
                : undefined;
            newPath =
                value !== undefined
                    ? newPath.replace(paramKey, value.toString())
                    : newPath.replace("/" + paramKey, '');
        });
        return ("" + newPath + (hasQueryParams ? "?" + queryParamsString : '')).toString();
    };
    /*
   converts an array of params [123, 100] to an object
   Example: if the current this.path is /book/:id/page/:pageId it will return {id:123, pageId:100}
   */
    Route.prototype.getParamsObject = function (paramValues) {
        var params = [];
        utils_1.getRegexMatches(this.originalPath, regex_1.paramRegex, 
        // eslint-disable-next-line
        function (_a) {
            var _fullMatch = _a[0], _paramKey = _a[1], paramKeyWithoutColon = _a[2];
            params.push(paramKeyWithoutColon);
        });
        var result = paramValues.reduce(function (obj, paramValue, index) {
            obj[params[index]] = paramValue;
            return obj;
        }, {});
        return result;
    };
    return Route;
}());
exports.Route = Route;
//# sourceMappingURL=route.js.map